import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-action-tablet-lpr-failure-details',
    templateUrl: './action-tablet-lpr-failure-details.component.html',
    styleUrls: ['./action-tablet-lpr-failure-details.component.scss'],
    standalone: false
})
export class ActionTabletLprFailureDetailsComponent {

  resourceId: string;

  formGroup = new FormGroup({ numberplate: new FormControl('', [])});

  confirmAllowed = false;

  constructor(
    public dialogRef: MatDialogRef<ActionTabletLprFailureDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    this.resourceId = data.resourceId;

    this.formGroup.valueChanges.subscribe(value => {
      this.confirmAllowed = value.numberplate && value.numberplate.length > 1;
    });

  }

  public cancel() {
    this.dialogRef.close(null);
  }

  public confirm() {
    this.dialogRef.close(this.formGroup.controls['numberplate'].value);
  }

}
